(function () {
  'use strict';

  if (window.__nestMrcZeroNoteBlocker20260710) return;
  window.__nestMrcZeroNoteBlocker20260710 = 'v1-block-zero-mrc-note';

  function bodyText(body) {
    if (!body) return '';
    if (typeof body === 'string') return body;
    if (body instanceof URLSearchParams) return body.toString();
    if (window.FormData && body instanceof FormData) {
      var pairs = [];
      body.forEach(function (value, key) { pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value)); });
      return pairs.join('&');
    }
    try { return JSON.stringify(body); } catch (error) { return String(body); }
  }

  function decode(value) {
    try { return decodeURIComponent(String(value || '').replace(/\+/g, ' ')); } catch (error) { return String(value || ''); }
  }

  function urlText(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function isCartUpdate(url) {
    return /\/cart\/update(?:\.js)?(?:\?|$)/i.test(String(url || ''));
  }

  function isZeroMrcNote(url, body) {
    var text = decode(String(url || '') + '&' + bodyText(body));
    return isCartUpdate(url) && /(?:^|[?&\s{,])note/i.test(text) && /MRC:[^|&\s]*-0-[A-Z]{2}/i.test(text);
  }

  function fakeFetchResponse() {
    var payload = { ok: true, nestMrcZeroNoteBlocked: true };
    if (typeof Response === 'function') return Promise.resolve(new Response(JSON.stringify(payload), { status: 200, headers: { 'Content-Type': 'application/json' } }));
    return Promise.resolve({ ok: true, status: 200, json: function () { return Promise.resolve(payload); }, text: function () { return Promise.resolve(JSON.stringify(payload)); } });
  }

  function resolvedAjax($, context) {
    if ($ && $.Deferred) {
      var deferred = $.Deferred();
      window.setTimeout(function () { deferred.resolveWith(context || window, [{ ok: true, nestMrcZeroNoteBlocked: true }, 'success', { status: 200 }]); }, 0);
      return deferred.promise();
    }
    return Promise.resolve({ ok: true, nestMrcZeroNoteBlocked: true });
  }

  function remember(kind, url, body) {
    window.__nestMrcZeroNoteBlockerLast = { at: Date.now(), kind: kind, url: String(url || ''), body: decode(bodyText(body)).slice(0, 280) };
  }

  function patchFetch() {
    if (!window.fetch || window.fetch.__nestMrcZeroNoteBlocker20260710) return;
    var originalFetch = window.fetch;
    window.fetch = function () {
      var input = arguments[0];
      var init = arguments[1] || {};
      var url = urlText(input);
      var body = init.body;
      if (!body && input && typeof input !== 'string') { try { body = input.body; } catch (error) {} }
      if (isZeroMrcNote(url, body)) {
        remember('fetch', url, body);
        return fakeFetchResponse();
      }
      return originalFetch.apply(this, arguments);
    };
    window.fetch.__nestMrcZeroNoteBlocker20260710 = true;
  }

  function patchAjax() {
    var $ = window.jQuery || window.$;
    if (!$ || !$.ajax || $.ajax.__nestMrcZeroNoteBlocker20260710) return false;
    var originalAjax = $.ajax;
    $.ajax = function () {
      var context = this;
      var args = Array.prototype.slice.call(arguments);
      var options = args[0] && typeof args[0] === 'object' ? args[0] : args[1];
      var url = typeof args[0] === 'string' ? args[0] : options && options.url;
      var body = options && Object.prototype.hasOwnProperty.call(options, 'data') ? options.data : '';
      if (isZeroMrcNote(url, body)) {
        remember('ajax', url, body);
        return resolvedAjax($, context);
      }
      return originalAjax.apply(context, args);
    };
    $.ajax.__nestMrcZeroNoteBlocker20260710 = true;
    return true;
  }

  function patchXhr() {
    if (!window.XMLHttpRequest || window.XMLHttpRequest.prototype.__nestMrcZeroNoteBlocker20260710) return;
    var proto = window.XMLHttpRequest.prototype;
    var originalOpen = proto.open;
    var originalSend = proto.send;
    proto.open = function (method, url) {
      this.__nestMrcZeroNoteBlockerUrl20260710 = String(url || '');
      return originalOpen.apply(this, arguments);
    };
    proto.send = function (body) {
      var url = this.__nestMrcZeroNoteBlockerUrl20260710 || '';
      if (isZeroMrcNote(url, body)) {
        remember('xhr', url, body);
        try {
          Object.defineProperty(this, 'readyState', { value: 4, configurable: true });
          Object.defineProperty(this, 'status', { value: 200, configurable: true });
          Object.defineProperty(this, 'responseText', { value: JSON.stringify({ ok: true, nestMrcZeroNoteBlocked: true }), configurable: true });
          if (typeof this.onreadystatechange === 'function') this.onreadystatechange();
          if (typeof this.onload === 'function') this.onload();
          if (typeof this.onloadend === 'function') this.onloadend();
        } catch (error) {}
        return;
      }
      return originalSend.call(this, body);
    };
    proto.__nestMrcZeroNoteBlocker20260710 = true;
  }

  function install() {
    patchFetch();
    patchAjax();
    patchXhr();
  }

  install();
  var tries = 0;
  var timer = window.setInterval(function () {
    tries += 1;
    install();
    if (tries > 80 || ((window.jQuery || window.$) && (window.jQuery || window.$).ajax && (window.jQuery || window.$).ajax.__nestMrcZeroNoteBlocker20260710)) window.clearInterval(timer);
  }, 50);
})();